import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const slot = css`
  position: relative;

  > * {
    z-index: 1;
  }

  :before {
    content: none;
  }

  :after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${cssTheme.default.day.backgroundMinor};
    border-radius: ${spacing(2)};
  }
`
export const subtitle = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  display: block;
`
export const overlay = css`
  z-index: 1002;
`
